module.exports = __webpack_public_path__ + "img/quxiao6_pc.15e6e5a.jpg";